export class MontoImpuesto {
    public Value: number;

    constructor(impuesto: number){
        this.Value = impuesto;
    }
}
